<script>
import NavigationHeader from '../NavigationHeader.vue';
export default {
    name: 'Support',
    components: { NavigationHeader }
};
</script>

<template>
    <div class="container">
        <div id="support">
            <NavigationHeader route="/" navigationText="Zum Dashboard" title="Support" />
            <div class="wrapper">
                <p>Hast Du Fragen oder Anregungen? Dann kontaktiere uns einfach!</p>
                <p>
                    <a href="tel:+49 721 981 991 00">
                        <img src="@/assets/starface_icons_png/16/orange/phone_16.png" alt="Call" />
                        <b>+49 721 981 991 00</b> anrufen
                    </a>
                </p>
                <p>
                    <a href="mailto:up@starface.com">
                        <img src="@/assets/starface_icons_png/16/orange/mail_16.png" alt="Write" />
                        <b>up@starface.com</b> schreiben
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

#support {
    a {
        color: $orange;

        img {
            margin-right: 15px;
        }
    }
}
</style>
